/**
 * SB5-B — Shared "Coming soon" dialog.
 *
 * Surfaced by:
 *   - `/contracts` Add Contract button (Q12)
 *   - `/contracts` Edit pencil (Q12)
 *   - `/contract-positions` Edit modal Reactivate button (Q16)
 *
 * Single OK button; caller supplies title + body.
 */
import { type ReactElement } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

export interface ComingSoonDialogProps {
  open: boolean;
  onClose: () => void;
  title: string;
  body: string;
}

export function ComingSoonDialog({
  open,
  onClose,
  title,
  body,
}: ComingSoonDialogProps): ReactElement {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="coming-soon-dialog-title"
      aria-describedby="coming-soon-dialog-body"
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle id="coming-soon-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="coming-soon-dialog-body">
          {body}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}
